import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Settings hub parent route. The hub landing (`settings/index.tsx`) and its
 * campaign-scoped sub-pages (Campaign preferences, Billing) all render through
 * this Outlet, so the whole `/app/settings/*` tree stays under one door and one
 * paywall-exempt prefix. Kept intentionally bare — the landing page is the nav.
 */
export const Route = createFileRoute('/app/settings')({
  component: SettingsLayout,
});

function SettingsLayout() {
  return <Outlet />;
}
